
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Expert')
export class Expert {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('name', String)
    name = '';

    @JsonProperty('name_ar', String)
    nameAr = '';

    get getName() {
        return this.name || this.nameAr;
    }
}